import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { activeMemberships, postAuthPath } from "../auth/authState";

function LoadingScreen() {
  return (
    <div className="auth-loading" role="status" aria-live="polite">
      טוען…
    </div>
  );
}

export function RequireAuth() {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === "loading") {
    return <LoadingScreen />;
  }
  if (auth.status === "unauthenticated") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}

export function RequireTenant() {
  const auth = useAuth();

  if (auth.status === "loading") {
    return <LoadingScreen />;
  }
  if (auth.status === "unauthenticated") {
    return <Navigate to="/login" replace />;
  }
  if (auth.status === "authenticated_with_tenant") {
    return <Outlet />;
  }

  const active = activeMemberships(auth.memberships);
  if (active.length === 0) {
    return <Navigate to="/no-access" replace />;
  }
  if (active.length === 1) {
    return <LoadingScreen />;
  }
  return <Navigate to="/select-tenant" replace />;
}

export function GuestOnly() {
  const auth = useAuth();

  if (auth.status === "loading") {
    return <LoadingScreen />;
  }
  if (auth.status !== "unauthenticated") {
    return <Navigate to={postAuthPath(auth)} replace />;
  }
  return <Outlet />;
}

export function TenantGate() {
  const auth = useAuth();

  if (auth.status === "loading") {
    return <LoadingScreen />;
  }
  if (auth.status === "unauthenticated") {
    return <Navigate to="/login" replace />;
  }
  if (auth.status === "authenticated_with_tenant") {
    return <Navigate to="/" replace />;
  }

  const active = activeMemberships(auth.memberships);
  if (active.length === 0) {
    return <Navigate to="/no-access" replace />;
  }
  if (active.length === 1) {
    return <LoadingScreen />;
  }
  return <Outlet />;
}

export function NoAccessGate() {
  const auth = useAuth();

  if (auth.status === "loading") {
    return <LoadingScreen />;
  }
  if (auth.status === "unauthenticated") {
    return <Navigate to="/login" replace />;
  }
  if (auth.status === "authenticated_with_tenant") {
    return <Navigate to="/" replace />;
  }

  const active = activeMemberships(auth.memberships);
  if (active.length > 0) {
    return (
      <Navigate
        to={active.length === 1 ? "/" : "/select-tenant"}
        replace
      />
    );
  }
  return <Outlet />;
}
